import { alerts } from '@/utils/constants'

export function invoiceStageDisplay(stageHuman) {
  const maps = {
    'Exporter E-Sign Pending': 'Esign Required',
    'Exporter E-Sign Generated': 'Esign Required',
    'Invoice Processing': 'Processing',
    'Review and Submit': 'Esign Required'
  }
  return maps[stageHuman] ? maps[stageHuman] : stageHuman
}

export function invoiceStageClass(stageHuman) {
  const maps = {
    'Exporter E-Sign Pending': 'text-danger',
    'Exporter E-Sign Generated': 'text-danger',
    'Exporter Docs Pending': 'text-danger'
  }
  return maps[stageHuman] ? maps[stageHuman] : ''
}

export function percentSign(number) {
  try {
    return parseFloat(number).toFixed(1) + '%'
  } catch (e) {
    return 'N/A'
  }
}

export function capitalize(str) {
  return str.replace(/^\w/, (c) => c.toUpperCase())
}

export function sanitizeText(val) {
  try {
    const txt = val.slice(0, 1).toUpperCase() + val.slice(1, val.length)
    return txt
  } catch (e) {
    console.error('Failed to render text', e)
    return ''
  }
}

export function scaleNumber(value) {
  const num = parseFloat(value || 0)
  return num.toFixed(1)
}

export function isMailDatePastNDays(mailDateString, days) {
  if (mailDateString) {
    const mailDate = new Date(mailDateString) // Convert to Date object
    const currentDate = new Date() // Get today's date

    // Calculate the date N days after the mail_date
    const afterMailDate = new Date(mailDateString)
    afterMailDate.setDate(mailDate.getDate() + days)
    return currentDate > afterMailDate
  }
  return false
}

export function getAlertFlag(mailDate, revokeDate) {
  const DAY_IN_MS = 24 * 3600 * 1000
  const STAGE_1 = 15 * DAY_IN_MS // 15 days
  const STAGE_2 = 30 * DAY_IN_MS // 30 days
  const diff = revokeDate - mailDate
  const currentDate = new Date()
  const currDiff = currentDate - mailDate
  let secondParam = ''
  if (currDiff <= STAGE_1) {
    secondParam = 'earlyStage'
  } else if (currDiff > STAGE_1 && currDiff <= STAGE_2) {
    secondParam = 'midStage'
  } else {
    secondParam = 'laterStage'
  }
  if (diff <= STAGE_1) {
    return alerts?.timeRange1to15[secondParam]
  } else if (diff > STAGE_1 && diff <= STAGE_2) {
    return alerts?.timeRange1to30[secondParam]
  } else {
    return alerts?.timeRange1to16[secondParam]
  }
}

export function getTitle(monitoringData) {
  // eslint-disable-next-line camelcase
  const { financials, bank_statement, plaid, itr } = monitoringData

  const isFinancialsInactive = financials.active === false
  const isBankStatementInactive = bank_statement.active === false
  const isPlaidInactive = plaid.active === false
  const isItrInactive = itr.active === false

  if (isFinancialsInactive && isBankStatementInactive && isItrInactive) {
    return 'financialsBankItr'
  } else if (isFinancialsInactive && isPlaidInactive && isItrInactive) {
    return 'financialsPlaidItr'
  } else if (isFinancialsInactive && isBankStatementInactive) {
    return 'financialsAndBank'
  } else if (isFinancialsInactive && isPlaidInactive) {
    return 'financialsAndPlaid'
  } else if (isFinancialsInactive && isItrInactive) {
    return 'financialsAndItr'
  } else if (isBankStatementInactive && isItrInactive) {
    return 'bankAndItr'
  } else if (isPlaidInactive && isItrInactive) {
    return 'plaidAndItr'
  } else if (isFinancialsInactive) {
    return 'financials'
  } else if (isBankStatementInactive) {
    return 'bank'
  } else if (isPlaidInactive) {
    return 'plaid'
  } else if (isItrInactive) {
    return 'itr'
  }

  return 'accountDataRequired'
}
